const faqListingPage = document.querySelector('[faqs-listing]');
if(faqListingPage) {
    let hash = window.location.hash;
    if(hash) {
        openFaq(hash);
    }
    window.addEventListener("hashchange", (event) => {
        event.preventDefault();
        let hash = window.location.hash;
        openFaq(hash);
    });
}

function openFaq(hash) {
    hash = hash.replace('#', '');
    const faq = document.querySelector(`a[href='#${hash}']`);
    if(faq) {
        faq.classList.add('toggled');
    }
}